import { replace } from 'react-router';
import { z } from 'zod';
import { stateValidationSchema } from '~/app/features/crew/shop-now/shopNow';
import api from '~/utils/api';
import { uniqueId } from '~/utils/compute';
import { makeLoader, redirect } from '~/utils/routing';

const paramsSchema = z.object({
  store: z.string().min(1),
  idFromPlatform: z.string().min(1),
  shopNowId: z.string().min(1),
});

export const { loader, useLoaderData } = makeLoader(
  async ({ params }, appStore) => {
    const { store, idFromPlatform, shopNowId } = paramsSchema.parse(params);
    const result = stateValidationSchema.safeParse(appStore.getState());

    if (!result.success) {
      return replace(`/${store}/order/${idFromPlatform}`);
    }

    const { settings } = result.data;

    return api
      .fetchShopNowSession({
        params: { storefrontId: settings.storefrontId, shopNowId },
      })
      .then((session) => {
        appStore.dispatch(
          appStore.actions.crewClaim.setShopNowReplacementItems(
            session.lineItems,
          ),
        );

        appStore.dispatch(
          appStore.actions.crewClaim.setShopNowIncentiveAmountApplied(
            session.returnCreditIncentiveApplied.amount,
          ),
        );

        return {
          lineItems: session.lineItems.map((item) => ({
            ...item,
            gid: uniqueId(),
          })),
        };
      })
      .catch(() => redirect(`/${store}/order/${idFromPlatform}`));
  },
);
